export default __webpack_public_path__ + "static/media/AutomationEmail.f1d4dda8.svg";